export default {"src":"/_next/static/media/adobe.9b076833.svg","height":49,"width":134,"blurWidth":0,"blurHeight":0};